import type { IconName } from "@repo/fika-design-system/icon"

export type NodeType =
  | "paragraph"
  | "heading"
  | "blockquote"
  | "callout"
  | "codeBlock"
  | "bulletList"
  | "orderedList"
  | "listItem"
  | "math"
  | "embed"

type MarkType = "bold" | "italic" | "strike" | "code" | "highlight" | "link"

interface NodeInfo {
  type: NodeType
  label: string
  iconName: IconName
}

interface MarkInfo {
  type: MarkType
  label: string
  iconName: IconName
  group?: "format" | "other"
}

export const NODES: Record<NodeType, NodeInfo> = {
  paragraph: {
    type: "paragraph",
    label: "paragraph",
    iconName: "pilcrow",
  },
  heading: {
    type: "heading",
    label: "heading",
    iconName: "heading",
  },
  blockquote: {
    type: "blockquote",
    label: "blockquote",
    iconName: "message-square-quote",
  },
  callout: {
    type: "callout",
    label: "callout",
    iconName: "messages-square",
  },
  codeBlock: {
    type: "codeBlock",
    label: "code",
    iconName: "code",
  },
  bulletList: {
    type: "bulletList",
    label: "bullet list",
    iconName: "list",
  },
  orderedList: {
    type: "orderedList",
    label: "ordered list",
    iconName: "list-ordered",
  },
  listItem: {
    type: "listItem",
    label: "list item",
    iconName: "list-item",
  },
  math: {
    type: "math",
    label: "math",
    iconName: "function-square",
  },
  embed: {
    type: "embed",
    label: "embed",
    iconName: "globe",
  },
} as const

export const MARKS: Record<MarkType, MarkInfo> = {
  bold: {
    type: "bold",
    label: "bold",
    iconName: "bold",
    group: "format",
  },
  italic: {
    type: "italic",
    label: "italic",
    iconName: "italic",
    group: "format",
  },
  strike: {
    type: "strike",
    label: "strikethrough",
    iconName: "strikethrough",
    group: "format",
  },
  code: {
    type: "code",
    label: "code",
    iconName: "code",
    group: "format",
  },
  highlight: {
    type: "highlight",
    label: "highlight",
    iconName: "highlighter",
    group: "format",
  },
  link: {
    type: "link",
    label: "link",
    iconName: "link",
    group: "other",
  },
} as const
